export default {
	moreButtonText: "More",
};
